<template>
  <v-layout column align-center justify-start class="relative pt-5">
    <div
      style="
        width: 100%;
        height: 130px;
        background: rgb(236, 236, 236);
        position: absolute;
        top: 19px;
      "
    >
      <v-icon
        style="
          font-size: 158px;
          color: rgb(250, 251, 251);
          position: absolute;
          right: 9px;
          bottom: -27px;
        "
        >playlist_play</v-icon
      >
    </div>

    <v-card width="60%" class="transparent elevation-0">
      <v-toolbar class="transparent mb-1 elevation-0">
        <v-toolbar-items class style="margin-left: 0px">
          <v-select
            label="Language"
            v-model="selectedGalleryLanguage"
            :items="$store.state.languages"
            item-text="language"
            item-value="code"
            class="mr-5 lang-selector"
          ></v-select>
          <v-select
            label="Voice"
            v-model="selectedGalleryVoice"
            class="mr-5"
            :items="voices"
          ></v-select>
          <!--
			<v-select label="Intonation" data-vv-name="select" :items="intonation" class=""></v-select>
          -->
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn slot="activator" icon @click="searchGallery()">
            <v-icon>search</v-icon>
          </v-btn>
          <span>Search Gallery</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn
            slot="activator"
            icon
            @click="clearSearch()"
            :disabled="!selectedGalleryLanguage && !selectedGalleryVoice"
          >
            <v-icon>clear</v-icon>
          </v-btn>
          <span>Clear Search</span>
        </v-tooltip>
      </v-toolbar>
    </v-card>

    <!-- result list-->
    <v-card class="elevation-0 white mt-2" width="60%">
      <v-list two-line class="galleryList">
        <v-subheader>{{ galleryHeader }}</v-subheader>
        <template v-for="(item, index) in galleryItemsPaged">
          <v-divider
            v-if="item.divider"
            :inset="item.inset"
            :key="index"
          ></v-divider>

          <v-list-tile v-else :key="item.title" avatar>
            <v-list-tile-avatar>
              <img
                v-if="item.gender == 'female'"
                :src="item.avatar"
                style="
                  transform: scale(0.9);
                  background: linear-gradient(
                    rgb(176, 120, 177),
                    rgb(255, 255, 255)
                  );
                "
              />
              <img
                v-else
                :src="item.avatar"
                style="
                  transform: scale(0.9);
                  background: linear-gradient(
                    rgb(101, 155, 181),
                    rgb(255, 255, 255)
                  );
                "
              />
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title v-html="item.title"></v-list-tile-title>
              <v-list-tile-sub-title>{{
                item.languageName
              }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-layout row align-center justify-start>
                <div v-if="item.audioLinkOGG != null">
                  <span class="pr-1">OGG</span>
                  <v-tooltip bottom>
                    <lingo_audio
                      slot="activator"
                      :play_button_class="`icon-button-shadow`"
                      :play_button_color="`primary--text`"
                      :label_class="`mr-4`"
                      :label_text="``"
                      :file="item.audioLinkOGG"
                    ></lingo_audio>
                    <span>Hear {{ item.person }} Speak - OGG</span>
                  </v-tooltip>
                </div>

                <div v-if="item.audioLinkMP3 != null">
                  <span class="pr-1">MP3</span>
                  <v-tooltip bottom>
                    <lingo_audio
                      slot="activator"
                      :play_button_class="`icon-button-shadow`"
                      :play_button_color="`primary--text`"
                      :label_class="``"
                      :label_text="``"
                      :file="item.audioLinkMP3"
                    ></lingo_audio>
                    <span>Hear {{ item.person }} Speak - MP3</span>
                  </v-tooltip>
                </div>

                <div v-if="item.audioLinkWav != null">
                  <span class="pr-1">WAV</span>
                  <v-tooltip bottom>
                    <lingo_audio
                      slot="activator"
                      :play_button_class="`icon-button-shadow`"
                      :play_button_color="`primary--text`"
                      :label_class="``"
                      :label_text="``"
                      :file="item.audioLinkWav"
                    ></lingo_audio>
                    <span>Hear {{ item.person }} Speak - MP3</span>
                  </v-tooltip>
                </div>
                <!--
								<v-tooltip bottom>
									<v-btn slot="activator" icon color="primary--text" class="ml-3"><v-icon class="icon-button-shadow">star_border</v-icon></v-btn>
								<span>Add to Favorites</span>
								</v-tooltip>
                -->

                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    color="grey darken-3"
                    flat
                    class="ml-1"
                    @click="useVoice(item.languageCode, item.languageCodeFull)"
                    >Use it</v-btn
                  >
                  <span>Generate Audio With This Voice</span>
                </v-tooltip>
              </v-layout>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card>
    <v-pagination
      v-model="page"
      :length="calculatePages"
      total-visible="6"
      class="mt-2"
    ></v-pagination>
    <!-- end of result list-->
  </v-layout>
</template>

<style>
.elevation-0 {
  box-shadow: none !important;
}

.lang-selector .v-input__control {
  min-width: 350px;
}

.galleryList .v-list__tile__content,
.galleryList .v-list__tile__action {
  border-bottom: 1px solid #ececec;
}
</style>

<script>
import lingo_audio from "./AudioPlayer";

export default {
  name: "lingo_gallery",
  data() {
    return {
      voices: ["Male", "Female"],
      intonation: ["Even", "Excited", "Sad"],
      galleryItemsResultList: [],
      galleryItemsPaged: [],
      galleryHeader: null,
      selectedGalleryVoice: null,
      selectedGalleryLanguage: null,
      maxRowsPerPage: 6,
      page: 1,
      sampleStart: 0,
      sampleEnd: 0,
    };
  },
  watch: {
    page: {
      handler: function (newPage) {
        this.pageGalleryItems(newPage);
      },
      deep: true,
    },
  },
  methods: {
    useVoice(languageCode, languageCodeFull) {
      localStorage.setItem("selectedLanguageCode", languageCode);
      localStorage.setItem("selectedCharacter", languageCodeFull);
      this.$router.push({ path: "/app/audio_generator" });
    },
    searchGallery() {
      var result = this.filterByVoice(this.$store.state.samples);
      result = this.filterByLanguage(result);
      this.galleryItemsResultList = result;
      this.page = 1;
      this.pageGalleryItems(this.page);
    },
    clearSearch() {
      this.selectedGalleryVoice = null;
      this.selectedGalleryLanguage = null;
      this.searchGallery();
    },
    pageGalleryItems(currentPage) {
      this.sampleStart = (currentPage - 1) * this.maxRowsPerPage;
      this.sampleEnd =
        this.galleryItemsResultList.length - this.sampleStart >=
        this.maxRowsPerPage
          ? this.sampleStart + this.maxRowsPerPage
          : this.galleryItemsResultList.length;
      this.galleryItemsPaged = this.galleryItemsResultList.slice(
        this.sampleStart,
        this.sampleEnd
      );
      this.updateGalleryHeader();
    },
    filterByVoice(samples) {
      var result = [];
      for (var sample in samples) {
        if (
          this.compareProperty(
            this.selectedGalleryVoice,
            samples[sample].gender
          )
        ) {
          result.push(samples[sample]);
        }
      }
      return result;
    },
    filterByLanguage(samples) {
      var result = [];
      for (var sample in samples) {
        if (
          this.compareProperty(
            this.selectedGalleryLanguage,
            samples[sample].languageCode
          )
        ) {
          result.push(samples[sample]);
        }
      }
      return result;
    },
    compareProperty(expected, actual) {
      if (actual == null) {
        return false;
      }
      if (expected == null) {
        return true;
      }
      return expected.toLowerCase() == actual.toLowerCase();
    },
    updateGalleryHeader() {
      var totalCount = this.galleryItemsResultList.length;
      this.galleryHeader =
        "Showing " +
        (this.sampleStart + 1) +
        " to " +
        this.sampleEnd +
        " of " +
        totalCount +
        " voices";
    },
  },
  components: {
    lingo_audio,
  },
  mounted() {
    this.galleryItemsResultList = this.$store.state.samples;
    this.pageGalleryItems(this.page);
  },
  computed: {
    calculatePages() {
      if (!this.galleryItemsResultList) {
        return 0;
      }
      return Math.ceil(
        this.galleryItemsResultList.length / this.maxRowsPerPage
      );
    },
  },
};
</script>
